import React from 'react';
import { CheckCircle } from 'lucide-react';
import BookAppointmentButton from '../BookAppointmentButton';

const TRUST_POINTS = ['Transparent Process', 'Best Rates', 'Expert Advisory'];

export const HeroStats = ({ stats }) => (
  <div className="grid grid-cols-2 gap-6 pt-4">
    {stats.map((stat) => (
      <div key={stat.label} className="space-y-1">
        <div className="text-3xl font-bold text-cyan-600">{stat.value}</div>
        <div className="text-sm text-gray-600">{stat.label}</div>
      </div>
    ))}
  </div>
);

export const HeroCTA = () => (
  <div className="flex flex-col sm:flex-row gap-4 pt-4">
    <BookAppointmentButton size="lg" className="text-lg px-8 py-6" testId="hero-book-appointment-btn" />
  </div>
);

export const HeroTrustPoints = () => (
  <div className="flex items-center gap-6 pt-6">
    {TRUST_POINTS.map((point) => (
      <div key={point} className="flex items-center text-sm text-gray-600">
        <CheckCircle className="w-5 h-5 text-green-500 mr-2" />
        {point}
      </div>
    ))}
  </div>
);
